module.exports = __webpack_public_path__ + "static/media/loading.383a3c2a.gif";